import update from 'immutability-helper';
import { initialState } from '../state/translationsState';
import * as actionTypes from '../actionTypes/translationsActionTypes';
import get from 'lodash/get';
import createReducer from '../utils/createReducer';

const reducer = {
  [actionTypes.START_FETCHING_TRANSLATIONS]: (state, action) =>
    update(state, {
      translations: {
        isFetching: { $set: true }
      }
    }),

  [actionTypes.SAVE_TRANSLATIONS]: (state, action) => {
    const screenLabels = action.payload.is_feature_metadata ? get(action.payload, 'feature_labels', {}) : get(action.payload, 'screen_labels', {});
    const data = {
      ...state['translations']['data'],
      ...screenLabels
    };

    return update(state, {
      translations: {
        data: { $set: data },
        error: { $set: '' },
        isFetching: { $set: false }
      }
    });
  },
  [actionTypes.ERROR_FETCHING_TRANSLATIONS]: (state, action) =>
    update(state, {
      translations: {
        error: { $set: action.payload },
        isFetching: { $set: false }
      }
    }),
  [actionTypes.CLEAR_TRANSLATIONS]: (state, action) => initialState
};

export default createReducer(initialState, reducer);
